export default __webpack_public_path__ + "static/media/I.0651558f.svg";